const ITEMS = [
  'Websites & Web Apps', 'Software & Tools', 'Stripe Integrations',
  'Custom Commissions', 'Proven In Production',
  'AU Based', 'No Templates',
]

const TRACK = [...ITEMS, ...ITEMS]

export default function Marquee() {
  return (
    <div style={{
      width: '100%', overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.04)',
      borderBottom: '1px solid rgba(255,255,255,0.04)',
      background: 'rgba(255,255,255,0.012)',
      padding: '14px 0',
      position: 'relative',
    }}>
      {/* Fade edges */}
      <div style={{
        position: 'absolute', left: 0, top: 0, bottom: 0, width: 120, zIndex: 2,
        background: 'linear-gradient(90deg, #000, transparent)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', right: 0, top: 0, bottom: 0, width: 120, zIndex: 2,
        background: 'linear-gradient(270deg, #000, transparent)',
        pointerEvents: 'none',
      }} />

      <div style={{
        display: 'flex', gap: 0,
        animation: 'marqueeScroll 28s linear infinite',
        width: 'max-content',
      }}>
        {TRACK.map((item, i) => (
          <span key={i} style={{
            display: 'inline-flex', alignItems: 'center', gap: 20,
            padding: '0 28px',
            fontSize: 11, fontWeight: 600,
            letterSpacing: '.18em', textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.5)',
            fontFamily: 'Geist Variable, sans-serif',
            whiteSpace: 'nowrap',
          }}>
            {item}
            <span style={{ color: 'rgba(6,182,212,0.4)', fontSize: 14 }}>·</span>
          </span>
        ))}
      </div>

      <style>{`
        @keyframes marqueeScroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  )
}
